<template>
  <relatorio_list tipo="2"></relatorio_list>
</template>

<script>
import RelatorioList from "./List";

export default {
  components: {
    relatorio_list: RelatorioList
  }
};
</script>